// extracted by mini-css-extract-plugin
module.exports = {"selectorLink":"LanguageSelector_selectorLink__3WqRJ","flag":"LanguageSelector_flag__1-JHL"};